
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class CookieNotification extends Vue {
    @Prop() redirectUrl!: string
    @Prop() overlay!: boolean

    acceptCookies (): void {
        document.cookie = 'CookiesAccepted=true; max-age=31536000; path=/'
        if (this.isPageUrlFrontpage()) {
            window.location.href = this.redirectUrl
        } else {
            window.location.href = this.pageUrl
        }
    }

    checkCookiesConsent (): boolean {
        return !document.cookie.split('; ').includes('CookiesAccepted=true')
    }

    get pageUrl (): string {
        return this.$route.path
    }

    isPageUrlFrontpage (): boolean {
        return this.redirectUrl === this.$route.path
    }
}
